//export const LABIT_SERVER = "http://192.168.1.44:3000/dynamic";
export const DOMAIN = "https://test.labit.es/test";
export const LABIT_SERVER = "https://test.labit.es/simplerest/rest2.php";
//export const LABIT_PICTURE_SERVER = "http://192.168.1.44:8887/people_pics";
export const LABIT_PICTURE_SERVER = "https://test.labit.es/people_pics";
export const LABIT_RECOVERY_PASSWORD_SERVER =
  "https://test.labit.es/rest/Password-recovery.php";
export const LABIT_REST_SERVER = "https://test.labit.es/rest/";
export const LABIT_PUBLIC_FOLDER = "https://test.labit.es/uploads";
const DEBUG = false;

import { getToken } from "./localInfo";

export let post = async (query) => {
  const token = getToken();
  const body = {
    token,
    query,
  };
  try {
    if (DEBUG) {
      console.log(body);
    }
    const response = await fetch(LABIT_SERVER, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    const data = await response.json();
    if (DEBUG) {
      console.log(data);
    }
    return data;
  } catch (e) {
    console.log(e);
  }
};

export let rememberPassword = async (email) => {
  try {
    if (DEBUG) {
      console.log(email);
    }
    const response = await fetch(LABIT_RECOVERY_PASSWORD_SERVER, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email }),
    });
    const data = await response.json();
    if (DEBUG) {
      console.log(data);
    }
    return data;
  } catch (e) {
    console.log(e);
  }
};

export let rpost = async (endpoint, body, responseType = "json") => {
  body.token = getToken();
  try {
    const endpointURL = LABIT_REST_SERVER + endpoint + ".php";
    if (DEBUG) {
      console.log(endpointURL);
      console.log(body);
    }
    const response = await fetch(endpointURL, {
      method: "post",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    });
    let data = null;
    if (responseType === "json") {
      data = await response.json();
    } else {
      data = await response.text();
    }
    if (DEBUG) {
      console.log(data);
    }
    return data;
  } catch (e) {
    console.log(e);
  }
};
